export function FeatureFlagElse(featureFlagService) {
    'ngInject';
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let featureToCheck;
            scope.$watchCollection(() => featureFlagService.data, toggleFeature);
            attrs.$observe('featureFlagElse', value => {
                featureToCheck = value;
                toggleFeature(featureFlagService.data);
            });

            function toggleFeature(data) {
                let display = data.features.has(featureToCheck) ? 'none' : '';
                element.css('display', display);
            }
        }
    };
}
